export const DEPOSIT_LIMIT_REQUIRED_ALERT_ID = "DEPOSIT_LIMIT_REQUIRED_ALERT_ID";
